import React from 'react'
import { Box, Tabs, IconButton } from '@mui/material';
import { Outlet, useParams, useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LinkTab from '../../components/common/tabs/LinkTab';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const InventoryMngPage = () => {
    const { whUuid } = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    // 현재 탭 판별
    const isHistory = location.pathname.includes('/history');
    const [value, setValue] = React.useState(isHistory ? 1 : 0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // 창고 목록으로 돌아가기
    const handleGoBack = () => {
        navigate('/inventorymng');
    };

    return (
        <Box>
            <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <IconButton size="small" onClick={handleGoBack} sx={{ mr: 1 }}>
                    <ArrowBackIcon fontSize="small" aria-label="goBack" />
                </IconButton>
                <Box sx={{ flexGrow: 1, minWidth: 0 }}>
                    <BreadcrumbsContainer title="제품관리/창고 관리/창고 재고" icon="warehouse" />
                </Box>
            </Box>
            <Box sx={{ width: '100%', mt: 2 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={value} onChange={handleChange} aria-label="nav tabs example">
                        <LinkTab label="창고 관리" to={`/inventorymng/${whUuid}`} />
                        <LinkTab label="재고 이력" to={`/inventorymng/${whUuid}/history`} />
                    </Tabs>
                </Box>
            </Box>

            <Outlet />
        </Box>
    );
};

export default InventoryMngPage;
